"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SIAPageTop = _interopRequireDefault(require("./SIAPageTop/SIAPageTop"));
var _SIACMSContent = _interopRequireDefault(require("../SIACMSContent/SIACMSContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-page {\n  display: flex;\n  flex-direction: column;\n  max-width: 66rem;\n  margin: auto; }\n\n.sia-page-bottom {\n  display: flex;\n  flex-direction: column;\n  gap: 24px; }\n\n@media (max-width: 66rem) {\n  .sia-page-bottom {\n    padding-inline: 16px; } }\n";
  const fileName = "SIAPage_SIAPage";
  const element = document.querySelector("style[data-sass-component='SIAPage_SIAPage']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAPage = _ref => {
  let {
    title,
    lang,
    page_top,
    page_bottom,
    history,
    translate,
    captchaKey,
    inFormMethods,
    getParagraph,
    organisationData
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-page"
  }, /*#__PURE__*/_react.default.createElement(_SIAPageTop.default, {
    title: title,
    lead: page_top.page_lead,
    subleads: page_top.page_sub_lead,
    lang: lang,
    media: page_top.media,
    bgColor: page_top.bgColor
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-page-bottom"
  }, /*#__PURE__*/_react.default.createElement(_SIACMSContent.default, {
    lang: lang,
    items: page_bottom,
    history: history,
    translate: translate,
    captchaKey: captchaKey,
    inFormMethods: inFormMethods,
    getParagraph: getParagraph,
    organisationData: organisationData
  })));
};
SIAPage.propTypes = {
  page_top: _propTypes.default.object.isRequired,
  lang: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  page_bottom: _propTypes.default.oneOfType([_propTypes.default.object.isRequired, _propTypes.default.array.isRequired])
};
var _default = exports.default = SIAPage;